import { render, staticRenderFns } from "./modal-extend-booking.vue?vue&type=template&id=15a2ce37&scoped=true"
import script from "./modal-extend-booking.vue?vue&type=script&setup=true&lang=ts"
export * from "./modal-extend-booking.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./modal-extend-booking.vue?vue&type=style&index=0&id=15a2ce37&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a2ce37",
  null
  
)

export default component.exports